import React, { useEffect, useRef, useState } from "react";

import { Grid, TextField, Button, Dialog, DialogContent, Select, FormControl, InputLabel } from "@material-ui/core/";
import { toast } from "react-toastify";
import QrReader from "react-qr-reader";

import EventApi from "../../services/event";
import ControlResult from "./ControlResult";
import Confirmed from "./Confirmed";
import Loading from "../../components/Loading";
import { addData, addMultipleData, getData, initDB, updateData } from "../../db";
import { getImprimixApiToken } from "../../utils/TokenCache";
import imprimix from "../../services/imprimix";
import useEventInfo from "../../hooks/useEventInfo";
import usePersonData from "../../hooks/usePersonData";
import { formatDateToTimeZoneUTC } from "../../utils/Functions";

const AccessControl = (props) => {
    const { eventData, eventDataCache, fetchEventById } = useEventInfo();
    const { registerAccess, registerAtActivity } = usePersonData();
    const [people, setPeople] = useState([]);
    const [status, setStatus] = useState([]);
    const [person, setPerson] = useState({});
    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);
    const [event, setEvent] = useState({});
    const [state, setState] = useState(true);
    const [searchType, setSearchType] = useState("qrcode");
    const [qrScan, setQrScan] = useState({
        delay: 500,
        result: "Posicione o QR code para leitura",
    });
    const [alreadyConfirmed, setAlreadyConfirmed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isBuffering, setIsBuffering] = useState(true);
    const [isScanning, setIsScanning] = useState(false);
    const [peopleCache, setPeopleCache] = useState(new Map());
    const [isDBReady, setIsDBReady] = useState(false);
    const [isDBWorking, setIsDBWorking] = useState(false);
    const [activity, setActivity] = useState({});

    const isActivityControl = props.computedMatch?.params?.activity_id || props.match.params.activity_id ? true : false;

    /** QRCODE READER */
    const [code, setCode] = useState("");
    const timerRef = useRef(null);

    const handleInputChange = async (event) => {
        const newCode = event.target.value;
        setCode(newCode);

        const id = newCode;
        setIsLoading(true);
        setIsBuffering(true);

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(async () => {
            try {
                const token = await getImprimixApiToken();

                const guestData = await imprimix.getDataById(id, token);

                // console.log("************\nguestData", guestData);

                if (!guestData || !guestData?.data || !guestData?.data?.data) {
                    toast.error("Convidado não foi encontrado");
                    setIsLoading(false);
                    setIsBuffering(false);
                    setIsScanning(false);
                    setSearch("");
                    return;
                }

                const eventDay = `${new Date(guestData.data.data.data).getDate() || "30"}`;

                let newGuest = {
                    name: guestData.data.data.nome,
                    rfid: JSON.stringify(guestData.data.data).slice(0, 398),
                    role: "",
                    certificate: 0,
                    enable: true,
                    vip: false,
                    status_id: 5,
                    category_id: 1,
                    grade_id: 1,
                    is_guest: true,
                    event_id: props?.computedMatch?.params?.event_id || 1,
                    accepted_terms: true,
                    allow_marketing: true,
                    allow_thirdparty_mkt: true,
                    event_days_subscribed: [eventDay],
                    event_days_attended: [eventDay],
                    interage_id: id,
                };

                EventApi.createPerson({
                    ...newGuest,
                })
                    .then(async (resp) => {
                        if (!!resp.data) {
                            if (!!resp.data.data) {
                                // console.log("1 found by qrcode\n", { data: resp.data.data });
                                let extraData = JSON.parse(resp.data.data.rfid);
                                setPeople([{ ...resp.data.data, ...extraData }]);
                                setPerson({ ...resp.data.data, ...extraData });
                                setIsLoading(false);
                                setIsBuffering(false);
                                setIsScanning(false);
                                setSearch("");
                                handleOpen();
                            } else {
                                if (!!resp.data.interage_id) {
                                    // console.log("2 found by qrcode\n", { data: resp.data });
                                    let extraData = JSON.parse(resp.data.rfid);
                                    setPeople([{ ...resp.data, ...extraData }]);
                                    setPerson({ ...resp.data, ...extraData });
                                    setIsLoading(false);
                                    setIsBuffering(false);
                                    setIsScanning(false);
                                    setSearch("");
                                    handleOpen();
                                } else toast.error("Convidado não foi encontrado");
                            }
                        } else {
                            toast.error("Convidado não foi encontrado");
                            // setPeople([resp.data.data]);
                            // setPerson(resp.data.data);
                            // setIsLoading(false);
                            // setIsBuffering(false);
                            // setIsScanning(false);
                            // setSearch("");
                            // handleOpen();
                        }
                    })
                    .catch(function (error) {
                        console.log("scan error\n", { error });
                        toast.error(`${error}`);
                        setIsLoading(false);
                        setIsBuffering(false);
                        setIsScanning(false);
                        setSearch("");
                    });
            } catch (error) {
                console.error("Erro ao enviar o código para a API:", error);
            }

            setCode("");
            setIsLoading(false);
            setIsBuffering(false);
            setIsScanning(false);
            setSearch("");
        }, 500); // wait 500ms
    };

    /** END READER */

    const SHOWED_UP_ID = 5; //props.data.status.find(e=>{return e?.name === 'SHOWED_UP'}).id || 5;

    const handleInitDB = async () => {
        console.log("starting db");
        const status = await initDB();
        setIsDBReady(!!status);
    };

    const handleAddPersonToIndexedDB = async (data) => {
        try {
            await addData("people", data);
        } catch (err) {
            if (err instanceof Error) {
                console.log(err.message);
            } else {
                console.log("Something went wrong");
            }
        }
    };

    const handleUpdatePerson = async (id, data) => {
        try {
            await updateData("people", id, data);
        } catch (err) {
            if (err instanceof Error) {
                console.log(err.message);
            } else {
                console.log("Something went wrong");
            }
        }
    };

    const handleGetPersonFromIndexedDB = async (id = null) => {
        try {
            const res = await getData("people", id);
            console.log("handleGetPersonFromIndexedDB", res);
            return res;
        } catch (err) {
            if (err instanceof Error) {
                console.log(err.message);
            } else {
                console.log("Something went wrong");
            }
            return false;
        }
    };

    const getPersonFromCache = (id) => {
        return peopleCache.get(id);
    };

    function onChange(event) {
        setSearch(event.target.value);
    }

    function onChangeSearchType(event) {
        setSearchType(event.target.value);
    }

    async function handleScan(data) {
        if (!!data && !isBuffering && !isScanning) {
            setIsBuffering(true);
            setIsScanning(true);
            await searchByQrCode(data);
        }
    }

    function handleScanError(err) {
        console.log(err);
        toast.error("Não foi possível ler o QR Code");
    }

    function closeInTime() {
        setTimeout(() => handleCloseInTime(), 3000);
    }

    function handleCloseInTime() {
        setAlreadyConfirmed(false);
        setSearchType("qrcode");
        setIsLoading(false);
        handleClose();
    }

    const handleUpdateStateCache = (key, data) => {
        const updatedCache = new Map(peopleCache);
        updatedCache.set(key, data);
        setPeopleCache(updatedCache);
    };

    async function searchByQrCode(qrcodeData) {
        const id = qrcodeData;
        setIsLoading(true);
        setIsBuffering(true);

        try {
            let result;

            if (!isActivityControl) {
                result = await registerAccess({
                    registered_at: formatDateToTimeZoneUTC(new Date()),
                    registered_by: getCurrentUser(),
                    person_id: id,
                });
            } else {
                let activityId = props?.computedMatch?.params?.activity_id || props?.match?.params?.activity_id;
                result = await registerAtActivity(activityId, {
                    registered_at: formatDateToTimeZoneUTC(new Date()),
                    registered_by: getCurrentUser(),
                    obs: `${new Date().toLocaleTimeString("pt-BR")}`,
                    activity_id: activityId,
                    person_id: id,
                });
            }

            if (result) {
                setPerson(result);
                setPeople([result]);
                handleOpen();
            } else {
                toast.error("Convidado não encontrado");
            }
        } catch (error) {
            console.error("Scan error:", error);
            toast.error("Erro ao buscar convidado");
        } finally {
            setIsLoading(false);
            setIsBuffering(false);
            setIsScanning(false);
            setSearch("");
        }
    }

    const getCurrentUser = () => {
        return "";
    };

    async function confirmPerson(person) {
        try {
            const { data } = await EventApi.updatePerson(person.id, {
                ...person,
                status_id: status ? (status.id ? status.id : SHOWED_UP_ID) : SHOWED_UP_ID,
                event_days_subscribed: person?.event_days_subscribed || ["*"],
                event_days_attended: person?.event_days_attended
                    ? [...person.event_days_attended, `${new Date().getDate()}`]
                    : [`${new Date().getDate()}`],
                address: person?.address
                    ? person.address + `#${new Date().toLocaleString("pt-BR")}`
                    : `#${new Date().toLocaleString("pt-BR")}`,
            });

            return data.data;
        } catch (error) {
            console.error("Error confirming person:", error);
            throw error;
        }
    }

    useEffect(() => {
        // if (!isDBReady) handleInitDB();
        async function getData() {
            const respEvent = eventDataCache
                ? eventDataCache
                : await fetchEventById(props?.computedMatch?.params?.event_id || 1);
            // const respPeople = await EventApi.getPersonByEvent(props.computedMatch.params.event_id);
            if (!!respEvent) {
                setEvent(respEvent);
            } else {
                toast.error("Evento não encontrado");
                setState(false);
            }

            if (props.computedMatch?.params?.activity_id || props.match.params.activity_id) {
                const respActivity = await EventApi.getActivity(
                    props.computedMatch?.params?.activity_id || props.match.params.activity_id
                );
                if (!!respActivity.data) {
                    setActivity(respActivity.data.data);
                } else {
                    toast.error("Atividade não encontrada");
                    setState(false);
                }
            }

            // if (!!respPeople.data) {
            //     const peopleMap = new Map();
            //     respPeople.data.data.forEach(person => {
            //         peopleMap.set(person.id, person);
            //     });

            //     console.log('adding people to state')
            //     setPeopleCache(peopleMap);
            //     console.log(peopleMap);

            //     console.log('addind people to db')
            //         addMultipleData('people', respPeople.data.data)
            //             .then(success => {
            //                 if (success) {
            //                     console.log('Data added');
            //                     setIsDBWorking(true);
            //                 }
            //                 else console.log('DB not working');
            //             })
            //     // if (isDBReady) {
            //     //     console.log('addind people to db')
            //     //     addMultipleData('people', respPeople.data.data)
            //     //         .then(success => {
            //     //             if (success) {
            //     //                 console.log('Data added');
            //     //                 setIsDBWorking(true);
            //     //             }
            //     //             else console.log('DB not working');
            //     //         })
            //     // }
            // }
            setIsBuffering(false);
        }
        getData();
    }, []);

    async function onSubmit(event) {
        event.preventDefault();
        if (searchType === "name") {
            console.log("busca por nome");
            EventApi.getAllPersonByEvent(props?.computedMatch?.params?.event_id || 1, {
                name: search,
            })
                .then((resp) => {
                    if (!!resp.data) {
                        if (!!resp.data.data) {
                            console.log("resposta busca por nome");
                            console.log(resp.data.data);
                            setPeople(resp.data.data);
                            EventApi.getStatus()
                                .then((respStatus) => {
                                    if (!!respStatus.data) {
                                        respStatus.data.data.forEach((item) => {
                                            const { id } = item;
                                            const data = status;
                                            data[id] = item;
                                            setStatus(data);
                                        });
                                    }
                                })
                                .catch(function (error) {
                                    toast.error(error);
                                });
                        } else toast.error("Convidado não encontrado");
                    } else toast.error("Convidado não encontrado");
                })
                .catch(function (error) {
                    toast.error(error);
                });
        } else {
            setIsLoading(true);
            if (searchType === "position") {
                EventApi.getPeopleByPosition(props?.computedMatch?.params?.event_id || 1, { value: search })
                    .then(async (resp) => {
                        console.log(resp.data.data);
                        if (!!resp.data.data) {
                            if (resp.data.data.people.length > 0) {
                                setPeople(resp.data.data.people);
                                if (resp.data.data.people[0].status_id === SHOWED_UP_ID) {
                                    console.log("ja confirmado");
                                    // setAlreadyConfirmed(true);
                                    setPerson(resp.data.data.people[0]);
                                    setIsLoading(false);
                                    setIsBuffering(false);
                                } else {
                                    const updatedPerson = await confirmPerson(resp.data.data.people[0]);
                                    if (updatedPerson) {
                                        console.log(updatedPerson);
                                        setPerson(updatedPerson);
                                        setIsLoading(false);
                                        setIsBuffering(false);
                                    }
                                }
                            } else toast.error("Convidado não encontrado");
                        } else toast.error("Convidado não encontrado");
                    })
                    .catch(function (error) {
                        toast.error(error);
                    });
            } else {
                EventApi.getPersonById(search)
                    .then(async (resp) => {
                        if (!!resp.data) {
                            if (!!resp.data.data) {
                                console.log(resp.data.data);
                                setPeople([resp.data.data]);
                                if (resp.data.data.status_id === SHOWED_UP_ID) {
                                    // setAlreadyConfirmed(true);
                                    setPerson(resp.data.data);
                                    setIsLoading(false);
                                    setIsBuffering(false);
                                } else {
                                    const updatedPerson = await confirmPerson(resp.data.data);
                                    if (updatedPerson) {
                                        console.log(updatedPerson);
                                        setPerson(updatedPerson);
                                        setIsLoading(false);
                                        setIsBuffering(false);
                                    }
                                }
                            } else toast.error("Convidado não encontrado");
                        } else toast.error("Convidado não encontrado");
                    })
                    .catch(function (error) {
                        toast.error(error);
                        setIsLoading(false);
                        setIsBuffering(false);
                    });
            }
        }
        setIsLoading(false);
        setIsBuffering(false);
        setSearch("");
        handleOpen();
    }

    const handleOpen = () => {
        setOpen(true);
        closeInTime();
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {isBuffering && <Loading />}
            <Grid container direction="column" justifyContent="center" alignItems="center">
                {isActivityControl && activity && (
                    <div style={{ padding: "20px 20px 0 20px", textAlign: "center" }}>
                        <h2 style={{ padding: "5px" }}>{activity.name}</h2>
                        <div>
                            {activity.obs &&
                                activity.obs.split(",").map((item) => <p style={{ padding: "1px" }}>{item}</p>)}
                        </div>
                    </div>
                )}
                {/* QRCODE READER */}
                <form style={{ width: "80%", marginTop: "10%" }} onSubmit={onSubmit}>
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                        {searchType === "qrcode" && !isScanning ? (
                            <div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <QrReader
                                        delay={500}
                                        style={{
                                            height: "100%",
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                        onError={handleScanError}
                                        onScan={handleScan}
                                        facingMode="environment"
                                    />
                                </div>
                                <div>
                                    <p style={{ fontSize: "20px", textAlign: "center" }}>{qrScan.result}</p>
                                </div>
                            </div>
                        ) : null}
                        {!isActivityControl && (
                            <FormControl variant="filled" fullWidth>
                                <InputLabel>Buscar por:</InputLabel>
                                <Select
                                    native
                                    defaultValue={searchType}
                                    onChange={onChangeSearchType}
                                    value={searchType}
                                >
                                    {/* <option value={'name'}>Nome</option>
                            <option value={'id'}>ID</option> */}
                                    {/* <option value={'position'}>Posição</option> */}
                                    <option value={"qrcode"}>QR Code</option>
                                </Select>
                            </FormControl>
                        )}
                        {searchType !== "qrcode" ? (
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                required
                                label={searchType === "name" ? "Nome" : searchType === "id" ? "ID" : "Posição"}
                                onChange={onChange}
                                value={search}
                                autoFocus
                            />
                        ) : null}
                    </Grid>
                    {searchType !== "qrcode" ? (
                        <div>
                            <Button type="submit" fullWidth variant="contained" color="primary">
                                Buscar
                            </Button>
                        </div>
                    ) : null}
                </form>
                <Grid>
                    <div style={{ maxWidth: "100%" }}>
                        <Dialog fullScreen open={open} onClose={handleClose}>
                            <DialogContent
                                style={{
                                    background: alreadyConfirmed
                                        ? "#EC2A5F"
                                        : isLoading || searchType === "name"
                                        ? "#ecf1f8"
                                        : "#2aec5e",
                                }}
                            >
                                {searchType === "name" ? (
                                    <ControlResult
                                        data={{ people, status, event, searchType }}
                                        setSearchType={setSearchType}
                                        close={handleClose}
                                    />
                                ) : isLoading ? (
                                    ""
                                ) : (
                                    <Confirmed
                                        data={{ person, event, alreadyConfirmed, isLoading, isActivityControl }}
                                        close={handleClose}
                                        setSearchType={setSearchType}
                                        setAlreadyConfirmed={setAlreadyConfirmed}
                                        setIsLoading={setIsLoading}
                                    />
                                )}
                            </DialogContent>
                        </Dialog>
                    </div>
                </Grid>
            </Grid>
        </>
    );
};

export default AccessControl;
